import React from 'react';
import ChatText from './ChatText';

const ChatBubble = ({ transmission, children }) => (
  <ChatText transmission={transmission}>{children}</ChatText>
);

export default ChatBubble;
